/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_See_BreakdownInputs */

const en_btn_see_breakdown = /** @type {(inputs: Btn_See_BreakdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Breakdown`)
};

/**
* | output |
* | --- |
* | "See Breakdown" |
*
* @param {Btn_See_BreakdownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_see_breakdown = /** @type {((inputs?: Btn_See_BreakdownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_See_BreakdownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_see_breakdown(inputs)
});